
import React from 'react';
import { TableRow, TableCell, TableBody } from '@/components/ui/table';
import { format } from 'date-fns';
import { Transaction } from '@/types/payment';

interface TransactionTableRowsProps {
  transactions: Transaction[];
}

const TransactionTableRows: React.FC<TransactionTableRowsProps> = ({ transactions }) => {
  if (transactions.length === 0) {
    return (
      <TableBody>
        <TableRow>
          <TableCell colSpan={10} className="text-center h-24 text-muted-foreground">
            No results found.
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  return (
    <TableBody>
      {transactions.map(tx => (
        <TableRow key={tx.id}>
          <TableCell className="font-mono text-xs">{tx.id}</TableCell>
          <TableCell>{tx.sender}</TableCell>
          <TableCell>{tx.senderEmail}</TableCell>
          <TableCell>{tx.recipient}</TableCell>
          <TableCell>{tx.recipientEmail}</TableCell>
          <TableCell className="text-right">${tx.amount.toFixed(2)}</TableCell>
          <TableCell className="text-right">${tx.fee.toFixed(2)}</TableCell>
          <TableCell>{format(new Date(tx.timestamp), 'PPpp')}</TableCell>
          <TableCell>
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              tx.status === 'completed' ? 'bg-green-100 text-green-800' :
              tx.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
              'bg-red-100 text-red-800'
            }`}>
              {tx.status}
            </span>
          </TableCell>
          <TableCell>{tx.method}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TransactionTableRows;
